import { slotLocalDate } from "./timezone.js";

export function createInitialState() {
  return {
    screen: "date",
    // "wide" (conteneur ≥ WIDE_MIN_WIDTH) ou "narrow" : mesuré par index.js
    mode: "narrow",
    status: "idle",
    slots: [],
    selectedTimezone: null,
    selectedDate: null,
    selectedSlot: null,
    error: null,
    fields: {},
    form: {
      name: "",
      email: "",
      phone: "",
      message: ""
    },
    confirmation: null
  };
}

export function groupSlotsByDate(slots) {
  return slots.reduce((groups, slot) => {
    groups[slot.date] ||= [];
    groups[slot.date].push(slot);
    return groups;
  }, {});
}

// Regroupe par date LOCALE dans le fuseau d'affichage (un créneau tardif peut
// basculer au lendemain dans un fuseau très à l'est). Repli sur slot.date.
export function groupSlotsByDateInTz(slots, tz) {
  return slots.reduce((groups, slot) => {
    const key = (tz && slotLocalDate(slot.start, tz)) || slot.date;
    (groups[key] ||= []).push(slot);
    return groups;
  }, {});
}

// Premier jour disponible dans le fuseau d'affichage (présélection en mode large).
export function firstAvailableDate(slots, tz) {
  const dates = Object.keys(groupSlotsByDateInTz(slots, tz)).sort();
  return dates[0] || null;
}

export function getAvailableDays(slots) {
  return Object.entries(groupSlotsByDate(slots)).map(([date, daySlots]) => ({
    date,
    slots: daySlots,
    availableCount: daySlots.length
  }));
}

export function updateForm(state, form) {
  state.form = {
    ...state.form,
    ...form
  };
}
